var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Icon from "cms/components/front-office/contents/Icon";
import Link from "cms/components/front-office/contents/Link";
var Social = function (props) {
    var socialNetworks = props.socialNetworks;
    return (_jsx(_Fragment, { children: socialNetworks.map(function (social) {
            var _a = social.icon, id = _a.id, others = __rest(_a, ["id"]);
            var idSocial = social.id, url = social.url, title = social.title;
            if (url) {
                return (_jsx(Link, { url: url, external: true, title: title, "aria-label": title, children: _jsx(Icon, __assign({}, others)) }, idSocial));
            }
            return _jsx(_Fragment, {});
        }) }));
};
export default Social;
